import {Component, inject} from '@angular/core'
import {RouterOutlet} from '@angular/router'
import {FooterComponent} from '@sparbanken-syd/sparbanken-syd-theme'
import version from '../assets/package.json'
import {HeaderComponent} from './common/header/header.component'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'

@Component({
  selector: 'spb-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent
  ]
})
export class AppComponent {
  public version = version.version
  public copyrightYears = `2022-${new Date().getFullYear()}`
  public configService = inject(ConfigService)
}
